import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { useDeprecatedAllowedCustomEvents } from './useDeprecatedAllowedCustomEvents';
import { useMappingCustomEvents } from './useMappingCustomEvents';
import { AUDIENCE_INSIGHTS_CUSTOM_EVENTS_MAPPING_FEATURE_FLAG } from '../../featureFlags';

export const useCustomEvents = () => {
  const isAudienceCustomEventFFOn = useFeatureFlag(
    AUDIENCE_INSIGHTS_CUSTOM_EVENTS_MAPPING_FEATURE_FLAG,
  );
  return isAudienceCustomEventFFOn ? useMappingCustomEvents() : useDeprecatedAllowedCustomEvents();
};
